import React from "react";
import * as styled from "./styled";

const Button = ({
  children,
  onClick,
}: {
  children: React.ReactNode;
  onClick: () => void;
}) => {
  return <styled.Button onClick={onClick}>{children}</styled.Button>;
};

export default Button;
